import React from "react"
import styled from "styled-components"
import ButtonBase from "./buttonBase"
import IconPlay from "../icons/iconPlay"
import {
  themeColors,
  responsiveBreakpoints,
} from "../../theme/themeVariables.js"

const ButtonPlay = props => (
  <ButtonPlayInner>
    <ButtonBase>
      <IconPlay
        color={themeColors.black}
        widthMobile="40px"
        heightMobile="40px"
      />
    </ButtonBase>
  </ButtonPlayInner>
)

const ButtonPlayInner = styled.span`
  height: auto;
  width: auto;
  box-sizing: border-box;
  position: relative;
  > button {
    width: 40px;
    height: 40px;
    box-sizing: border-box;
    background-color: transparent;
    transition: all cubic-bezier(0, 0.5, 0, 1) 0.1s;
    text-decoration: none;
    border: 1px solid transparent;
    @media (min-width: ${responsiveBreakpoints.desktop}) {
      height: 58px;
      width: 58px;
    }

    svg {
      z-index: 10;
      path {
        transition: all cubic-bezier(0, 0.5, 0, 1) 0.1s;
        fill: ${themeColors.black};
        } 
      }
    &:hover {
      cursor: pointer;
      background-image:
      linear-gradient(${themeColors.black}, ${themeColors.black});
      background-position: 0% 100%;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      svg {
        rect{
          fill: transparent;
        }
        path {
          fill: ${themeColors.white};
        }
      }
    }
  }
`

export default ButtonPlay
